import type { BranchKey, WorkspaceKey } from '@festina-life/api'
import { Button } from '@festina-life/ui/actions'
import { useTranslate } from '@festina-life/ui/hooks'
import { useState } from 'react'

import { useWorkspaceManagerContext } from '../../../workspace/workspaceManagerContext'
import { WorkspaceCreationModal } from '../../workspaceCreationModal/WorkspaceCreationModal'

type Props = {
  branchKey: BranchKey
}

export const BranchTabsWorkspaceCreationModalButton = ({
  branchKey,
}: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const { onSwitch } = useWorkspaceManagerContext()
  const translate = useTranslate()

  const handleWorkspaceCreated = (workspaceKey: WorkspaceKey) => {
    void onSwitch(workspaceKey)
    setIsModalOpen(false)
  }

  return (
    <>
      <WorkspaceCreationModal
        onCreated={handleWorkspaceCreated}
        baseBranch={branchKey}
        isOpen={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
      />
      <Button
        startIcon="Plus"
        variant="primary"
        className="rounded-none"
        onClick={() => setIsModalOpen(true)}
      >
        {translate('workspace.createWorkspace.button')}
      </Button>
    </>
  )
}
